<hb-login-container>
    <div content>
        <p class="text-muted">Access denied</p>
        Please contact the administrator
    </div>
</hb-login-container>
